import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/app/environments/environment';
import { ChartDetails, ExcelDataModel, fomData, UserIdentityDocument, ChatHistoryDocument, ChatListDocument, ChatAnswerDocument, ChatHistoryResponse, SaveChatResponseRequest, SaveChatFeedbackRequest } from '../models/chatbotexpand.model';
import { BehaviorSubject, Subject, throwError } from 'rxjs';

export interface InsightsStartResponse {
  stream_id: string;
}
@Injectable({
  providedIn: 'root'
})
export class ChatbotService {
  getChatBotInsightsData(
    insightsData: any, selectedstudy: string, selectedclient: string, isTotalBase: string): Observable<string> {
    const body = {
      data: JSON.stringify(insightsData),
      study: selectedstudy,
      client: selectedclient,
      isTotalBase: isTotalBase
    };
    return this.http.post(
      `${this.apiBaseUrl}api/ChatBot/getChatBotGptRepsonse`,
      body,
      { responseType: 'text' }
    );
  }

  getInsightsData(
    isIndexSelected: any,
    insightsData: any,
    selectedstudy: string,
    selectedclient: string,
    selectionSummary: string,
    confidenceLevel: string,
    ShareColumn: string = '',
    BaseColumn: string = '',
    brand_name: string = '',
    funnelChartSelectedItem: string = '',
    widgetName: string = '',
    WidgetId: string = '',
    userMail: string = '',
    snapshotName: string = '',
    module_name: string = ''
  ): Observable<string> {

    const formData = new FormData();
    formData.append('isIndexSelected', isIndexSelected);
    formData.append('data', JSON.stringify(insightsData));
    formData.append('study', selectedstudy);
    formData.append('client', selectedclient);
    formData.append('selectionSummary', selectionSummary);
    formData.append('confidenceLevel', confidenceLevel);
    formData.append('shareColumn', ShareColumn);
    formData.append('baseColumn', BaseColumn);
    formData.append('brand_name', brand_name);
    formData.append('widget_name', widgetName);
    formData.append('widget_Id', WidgetId);
    formData.append('funnelChartSelectedItem', funnelChartSelectedItem);
    formData.append('userMail', userMail);
    formData.append('snapshot_name', snapshotName);
    formData.append('module_name', module_name);
    return this.http.post(
      `${this.apiBaseUrl}api/Snapshot/getSnapshotInsights`,
      formData,
      { responseType: 'text' }
    );

  }


  apiBaseUrl = environment.baseApiUrl;
  askMePythonUrl = environment.askMePythonUrl;
  constructor(private http: HttpClient) { }
  private variableTabDataSubject = new BehaviorSubject<any>('');
  variableTabData$ = this.variableTabDataSubject.asObservable();

  exportToPPT(data: ChartDetails): Observable<Blob> {
    const exportUrl = `${this.apiBaseUrl}api/ChatBot/pptARKExport`;
    return this.http.post(exportUrl, data, { responseType: 'blob' });
  }
  getDiagonistics1(request: any): Observable<any> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetDiagonistics';
    return (this.http
      .post<any>(
        `${this.apiBaseUrl}api/ChatBot/GetDiagonistics`,
        request,
      )
    );
  }
  exportToExcelARK(data: ExcelDataModel): Observable<Blob> {
    const exportUrl = `${this.apiBaseUrl}api/ChatBot/excelExportARK`;
    return this.http.post(exportUrl, data, { responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }
  exportToExcelARKSnapshot(data: any): Observable<Blob> {
    const exportUrl = `${this.apiBaseUrl}api/ChatBot/excelExportARKSnapshot`;
    return this.http.post(exportUrl, data, { responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }

  callPptExportSnapshot(imgString: string, data: any, isTredendDataRequired: boolean = false): Observable<Blob> {
    const url = `${this.apiBaseUrl}api/ChatBot/pptExportSnapshot`;
    let formData = new FormData();
    data.imgString = imgString;
    data.isTredendDataRequired = isTredendDataRequired;
    formData.append("inputObj", JSON.stringify(data));
    return this.http.post(url, formData, { responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }

  exportToExcelSnapshot(data: any): Observable<Blob> {
    const exportUrl = `${this.apiBaseUrl}api/ChatBot/pptExportSnapshot`;
    return this.http.post(exportUrl, data, { responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }
  getOutputData(
    inputQuery: string,
    selectedclient: string,
    selectedstudy: string,
    aggregatedVariables: any = [],
    formattedJSON: any,
    weightFilter?: Record<string, string>
  ): Observable<any> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetQuery';

    // You can append the additional parameter to the URL or include it in the request body, depending on your API requirements
    const body = {
      input_Query: inputQuery,
      selectedclient: selectedclient,
      selectedstudy: selectedstudy,
      aggregatedVariables: aggregatedVariables,
      formattedJSON: formattedJSON,
      ...(weightFilter ? { weightFilter: weightFilter } : {})
    };

    return this.http.post<any>(url, body).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }
  getDiagonistics(): Observable<any> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetDiagonistics';

    // You can append the additional parameter to the URL or include it in the request body, depending on your API requirements
    const body = {
      request: "inputQuery"
    };

    return this.http.post<any>(url, body).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }

  downloadDiagnosticsExcel(): Observable<Blob> {
    return this.http.post(`${this.apiBaseUrl}api/ChatBot/DownloadDiagnosticsExcel`, {}, {
      responseType: 'blob'
    });
  }

  getMcode(
    inputQuery: string,
    client_name: string,
    selectedStudy: string,
    chat_id: string

  ): Observable<any> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetMcode';

    // You can append the additional parameter to the URL or include it in the request body, depending on your API requirements
    const body = {
      input_Query: inputQuery,
      selectedClient: client_name,
      selectedStudy: selectedStudy,
      chat_id: chat_id
    };

    return this.http.post<any>(url, body).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(error);
      })
    );
  }

  accessCheck(client_name: string, study: string, bearer_token: string = '', session_id: string = ''): Observable<any> {
    const url = this.askMePythonUrl + 'access-check';
    const body = {
      client_name: client_name,
      study: study,
      bearer_token: bearer_token,
      session_id: session_id
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(url, body, { headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('AccessCheck error:', error);
        return throwError(() => error);
      })
    );
  }

  accessCheckAskMeAnything(client_name: string, study: string, bearer_token: string = ''): Observable<any> {
    const url = this.askMePythonUrl + 'access-check-askmeanything';
    const body = {
      client_name: client_name,
      study: study,
      bearer_token: bearer_token
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(url, body, { headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('AccessCheckAskMeAnything error:', error);
        return throwError(() => error);
      })
    );
  }

  generateRestrictedCache(
    client_name: string,
    study: string,
    bearer_token: string = '',
    session_id: string = '',
    modules_access: any = {},
    overwrite: boolean = true,
    include_blank_labels: boolean = false,
    ttl_seconds: number = 900
  ): Observable<any> {
    const url = this.askMePythonUrl + 'generate-restricted-cache';
    const body = {
      client_name,
      study,
      bearer_token,
      session_id,
      modules_access,
      overwrite,
      include_blank_labels,
      ttl_seconds
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(url, body, { headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('generateRestrictedCache error:', error);
        return throwError(() => error);
      })
    );
  }

  generateClientStudyContext(
    client_name: string,
    study: string,
    bearer_token: string = '',
    session_id: string = '',
    modules_access: any = {},
    overwrite: boolean = true,
    include_blank_labels: boolean = false,
    ttl_seconds: number = 900
  ): Observable<any> {
    const url = this.askMePythonUrl + 'generate-client-study-context';
    const body = {
      client_name,
      study,
      bearer_token,
      session_id,
      modules_access,
      overwrite,
      include_blank_labels,
      ttl_seconds
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(url, body, { headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('generateClientStudyContext error:', error);
        return throwError(() => error);
      })
    );
  }

  deleteRestrictedCache(bearer_token: string, session_id: string, delete_session_store: boolean = true): Observable<any> {
    const url = this.askMePythonUrl + 'delete-restricted-cache';
    const body = {
      bearer_token,
      session_id,
      delete_session_store
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(url, body, { headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('deleteRestrictedCache error:', error);
        return throwError(() => error);
      })
    );
  }

  deleteClientStudyContext(bearer_token: string, session_id: string): Observable<any> {
    const url = this.askMePythonUrl + 'delete-client-study-context';
    const body = {
      bearer_token,
      session_id
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(url, body, { headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('deleteClientStudyContext error:', error);
        return throwError(() => error);
      })
    );
  }

  //test

  // accessCheckByEmail(client_name: string, study: string, email: string, bearer_token: string = ''): Observable<any> {
  //   const url = this.askMePythonUrl + 'access-check-by-email';
  //   const body = {
  //     client_name: client_name,
  //     study: study,
  //     email: "yogesh.jain@kantar.com",
  //     bearer_token: bearer_token
  //   };
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json'
  //   });
  //   return this.http.post<any>(url, body, { headers }).pipe(
  //     catchError((error: HttpErrorResponse) => {
  //       console.error('AccessCheckByEmail error:', error);
  //       return throwError(() => error);
  //     })
  //   );
  // }


  getChatList(): Observable<string> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetChatList';
    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('GetChat error:', error);
        return throwError(() => error);
      })
    );
  }

  saveChatList(title: string, chatId?: string): Observable<string> {
    const url = this.apiBaseUrl + 'api/ChatBot/SaveChatList';
    const body = {
      ChatTitle: title,
      ChatId: chatId || ''
    };
    return this.http.post(url, body, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('SaveChat error:', error);
        return throwError(error);
      })
    );
  }

  saveChatHistory(request: SaveChatResponseRequest): Observable<string> {
    const url = this.apiBaseUrl + 'api/ChatBot/SaveChatResponse';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(url, request, { headers, responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('SaveChatHistory error:', error);
        return throwError(() => error);
      })
    );
  }

  getChatResponse(messageId: string): Observable<string> {
    const url = this.apiBaseUrl + 'api/ChatBot/GetChatResponse?messageId=' + encodeURIComponent(messageId);

    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('GetChatResponse error:', error);
        return throwError(() => error);
      })
    );
  }

  getLoadData(value: any): Observable<any> {
    const path = 'api/DataExplorer/getLoadData';
    return this.http.post<any>(this.apiBaseUrl + path, value).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(() => error);
      })
    );
  }

  getLoadDataBrandAnalysis(value: any): Observable<any> {
    const path = 'api/DataExplorer/getLoadDataBrandAnalysis';
    return this.http.post<any>(this.apiBaseUrl + path, value).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        return throwError(() => error);
      })
    );
  }

  getUserIdentity(userId: string): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/GetUserIdentity?userId=${encodeURIComponent(userId)}`;
    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('GetUserIdentity error:', error);
        return throwError(() => error);
      })
    );
  }

  saveUserIdentity(doc: UserIdentityDocument): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/SaveUserIdentity`;
    return this.http.post(url, doc, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('SaveUserIdentity error:', error);
        return throwError(() => error);
      })
    );
  }

  updateChatStarred(messageId: string, isStarred: boolean): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/UpdateChatStarred`;
    const body = {
      MessageId: messageId,
      IsStarred: isStarred
    };
    return this.http.post(url, body, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('UpdateChatStarred error:', error);
        return throwError(() => error);
      })
    );
  }

  getStarredMessages(): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/GetStarredMessages`;
    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('GetStarredMessages error:', error);
        return throwError(() => error);
      })
    );
  }

  saveChatFeedback(feedback: { MessageId: string; IsLiked: boolean | null; DislikeReason?: string }): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/SaveChatFeedback`;
    return this.http.post(url, feedback, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('SaveChatFeedback error:', error);
        return throwError(() => error);
      })
    );
  }

  deleteChatMessage(messageId: string): Observable<string> {
    const url = `${this.apiBaseUrl}api/ChatBot/DeleteChatMessage`;
    const body = {
      MessageId: messageId
    };
    return this.http.post(url, body, { responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('DeleteChatMessage error:', error);
        return throwError(() => error);
      })
    );
  }

  insights(
    client_name: string,
    study: string,
    session_id: string,
    bearer_token: string,
    mcode: number,
    markdown: string,
    query?: string,
    widget_details?: any
  ): Observable<string> {
    const url = '/insights';
    const body = {
      client_name: client_name,
      study: study,
      session_id: session_id,
      bearer_token: bearer_token,
      mcode: mcode,
      markdown: markdown,
      query: query || '',
      widget_details: widget_details || null
    };
    

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(url, body, { headers, responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Insights API error details:', error);
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
        console.error('Error body:', error.error);
        return throwError(() => error);
      })
    );
  }

  qna(
    client_name: string,
    study: string,
    session_id: string,
    bearer_token: string,
    mcode: number,
    markdown: string,
    query?: string,
    widget_details?: any
  ): Observable<string> {
    const url = this.askMePythonUrl + 'qna';
    const body = {
      client_name: client_name,
      study: study,
      session_id: session_id,
      bearer_token: bearer_token,
      mcode: mcode,
      markdown: markdown,
      query: query || '',
      widget_details: widget_details || null
    };


    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(url, body, { headers, responseType: 'text' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('QnA API error details:', error);
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
        console.error('Error body:', error.error);
        return throwError(() => error);
      })
    );
  }

  // SSE Streaming Methods
  startInsightsStream(
    client_name: string,
    study: string,
    session_id: string,
    bearer_token: string,
    mcode: number,
    markdown: string,
    query?: string,
    widget_details?: any
  ): Observable<InsightsStartResponse> {
    const url = this.askMePythonUrl + 'insights/start';
    const body = {
      client_name,
      study,
      session_id,
      bearer_token,
      mcode,
      markdown,
      query: query || '',
      widget_details: widget_details || null
    };

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<InsightsStartResponse>(url, body, { headers }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  startQnaStream(
    client_name: string,
    study: string,
    session_id: string,
    bearer_token: string,
    mcode: number,
    markdown: string,
    query?: string,
    widget_details?: any
  ): Observable<InsightsStartResponse> {
    const url = this.askMePythonUrl + 'qna/start';
    const body = {
      client_name,
      study,
      session_id,
      bearer_token,
      mcode,
      markdown,
      query: query || '',
      widget_details: widget_details || null
    };

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<InsightsStartResponse>(url, body, { headers }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  streamInsights(stream_id: string): Observable<string> {
    const url = `${this.askMePythonUrl}insights/stream/${encodeURIComponent(stream_id)}`;

    return new Observable<string>((observer) => {
      const es = new EventSource(url);

      es.onopen = (event) => {
        console.log(`[EVENTOURCE DEBUG] EventSource connection opened:`, {
          timestamp: new Date().toISOString(),
          readyState: es.readyState,
          url: url
        });
      };

      es.onmessage = (event) => {
        observer.next(event.data); // chunk
      };

      es.addEventListener('done', () => {
        observer.complete();
        es.close();
      });

      es.onerror = (err) => {
        console.error(`[EVENTOURCE DEBUG] EventSource error:`, {
          error: err,
          readyState: es.readyState,
          timestamp: new Date().toISOString()
        });
        observer.error(err);
        es.close();
      };

      return () => {
        es.close();
      };
    });
  }

  streamQna(stream_id: string): Observable<string> {
    const url = `${this.askMePythonUrl}qna/stream/${encodeURIComponent(stream_id)}`;

    return new Observable<string>((observer) => {
      const es = new EventSource(url);

      es.onmessage = (event) => {
        observer.next(event.data);
      };

      es.addEventListener('done', () => {
        observer.complete();
        es.close();
      });

      es.onerror = (err) => {
        observer.error(err);
        es.close();
      };

      return () => es.close();
    });
  }

  cancelStream(stream_id: string): Observable<any> {
    const url = `${this.askMePythonUrl}stream/cancel/${encodeURIComponent(stream_id)}`;
    return this.http.post(url, {}).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  // Orchestration APIs
  snapshotAgentStream(
    client_name: string,
    study: string,
    session_id: string,
    bearer_token: string,
    query: string,
    stream: boolean = true,
    debug_mode: boolean = false,
    snapshot_enabled_history: boolean = false,
    num_history_runs: number = 5
  ): Observable<any> {
    const url = `${this.askMePythonUrl}snapshot-agent/stream`;
    const body = {
      client_name,
      study,
      session_id,
      bearer_token,
      query,
      stream,
      debug_mode,
      snapshot_enabled_history,
      num_history_runs
    };

    return new Observable<any>((observer) => {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(async (response) => {
        if (!response.ok) {
          observer.error(new Error(`API responded with status ${response.status}: ${response.statusText}`));
          return;
        }
        if (!response.body) {
          observer.error('Response body is null');
          return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const parts = buffer.split('\n\n');
          buffer = parts.pop() || '';

          for (const part of parts) {
            const lines = part.split('\n');
            let eventType = 'message';
            let eventData = '';

            for (const line of lines) {
              if (line.startsWith('event: ')) {
                eventType = line.substring(7);
              } else if (line.startsWith('data: ')) {
                eventData = line.substring(6);
              }
            }

            if (eventData) {
              try {
                const parsedData = JSON.parse(eventData);
                // Return structured data to component
                observer.next({ event: eventType, data: parsedData });
              } catch (e) {
                // If not JSON, return as plain string
                observer.next({ event: eventType, data: eventData });
              }
            }
          }
        }
        observer.complete();
      }).catch((err) => {
        observer.error(err);
      });
    });
  }

  brandAnalysisAgentStream(
    client_name: string,
    study: string,
    session_id: string,
    bearer_token: string,
    query: string,
    stream: boolean = true,
    debug_mode: boolean = false,
    brandanalysis_enabled_history: boolean = false,
    num_history_runs: number = 5
  ): Observable<any> {
    const url = `${this.askMePythonUrl}brand-analysis-agent/stream`;
    const body = {
      client_name,
      study,
      session_id,
      bearer_token,
      query,
      stream,
      debug_mode,
      brandanalysis_enabled_history,
      num_history_runs
    };

    return new Observable<any>((observer) => {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(async (response) => {
        if (!response.ok) {
          observer.error(new Error(`API responded with status ${response.status}: ${response.statusText}`));
          return;
        }
        if (!response.body) {
          observer.error('Response body is null');
          return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const parts = buffer.split('\n\n');
          buffer = parts.pop() || '';

          for (const part of parts) {
            const lines = part.split('\n');
            let eventType = 'message';
            let eventData = '';

            for (const line of lines) {
              if (line.startsWith('event: ')) {
                eventType = line.substring(7);
              } else if (line.startsWith('data: ')) {
                eventData = line.substring(6);
              }
            }

            if (eventData) {
              try {
                const parsedData = JSON.parse(eventData);
                // Return structured data to component
                observer.next({ event: eventType, data: parsedData });
              } catch (e) {
                // If not JSON, return as plain string
                observer.next({ event: eventType, data: eventData });
              }
            }
          }
        }
        observer.complete();
      }).catch((err) => {
        observer.error(err);
      });

      return () => { }; // Optional: cancel fetch on unsubscribe
    });
  }

  crosstabAgentStream(
    client_name: string,
    study: string,
    session_id: string,
    bearer_token: string,
    query: string,
    stream: boolean = true,
    debug_mode: boolean = false,
    crosstab_enabled_history: boolean = false,
    num_history_runs: number = 5
  ): Observable<any> {
    const url = `${this.askMePythonUrl}crosstab-agent/stream`;
    const body = {
      client_name,
      study,
      session_id,
      bearer_token,
      query,
      stream,
      debug_mode,
      crosstab_enabled_history,
      num_history_runs
    };

    return new Observable<any>((observer) => {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(async (response) => {
        if (!response.ok) {
          observer.error(new Error(`API responded with status ${response.status}: ${response.statusText}`));
          return;
        }
        if (!response.body) {
          observer.error('Response body is null');
          return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const parts = buffer.split('\n\n');
          buffer = parts.pop() || '';

          for (const part of parts) {
            const lines = part.split('\n');
            let eventType = 'message';
            let eventData = '';

            for (const line of lines) {
              if (line.startsWith('event: ')) {
                eventType = line.substring(7);
              } else if (line.startsWith('data: ')) {
                eventData = line.substring(6);
              }
            }

            if (eventData) {
              try {
                const parsedData = JSON.parse(eventData);
                // Return structured data to component
                observer.next({ event: eventType, data: parsedData });
              } catch (e) {
                // If not JSON, return as plain string
                observer.next({ event: eventType, data: eventData });
              }
            }
          }
        }
        observer.complete();
      }).catch((err) => {
        observer.error(err);
      });

      return () => { }; // Optional: cancel fetch on unsubscribe
    });
  }

  ctapi(input_Query: string, selectedClient: string, selectedStudy: string, chat_id: string): Observable<any> {
    const url = `${this.apiBaseUrl}api/ChatBot/ctapi`;
    const body = { input_Query, selectedClient, selectedStudy, chat_id };
    return this.http.post<any>(url, body).pipe(catchError(this.handleError));
  }

  baapi(input_Query: string, selectedClient: string, selectedStudy: string, chat_id: string): Observable<any> {
    const url = `${this.apiBaseUrl}api/ChatBot/baapi`;
    const body = { input_Query, selectedClient, selectedStudy, chat_id };
    return this.http.post<any>(url, body).pipe(catchError(this.handleError));
  }

  teamapi(input_Query: string, selectedClient: string, selectedStudy: string, chat_id: string): Observable<any> {
    const url = `${this.apiBaseUrl}api/ChatBot/teamapi`;
    const body = { input_Query, selectedClient, selectedStudy, chat_id };
    return this.http.post<any>(url, body).pipe(catchError(this.handleError));
  }

  chatapi(payload: any): Observable<any> {
    const url = `${this.apiBaseUrl}api/ChatBot/chatapi`;
    return this.http.post<any>(url, payload).pipe(catchError(this.handleError));
  }

  teamapiAgentStream(
    client_name: string, study: string, session_id: string, bearer_token: string, query: string,
    stream: boolean = true, debug_mode: boolean = false,
    snapshot_enabled: boolean = true, crosstab_enabled: boolean = true, brand_analysis_enabled: boolean = true
  ): Observable<any> {
    const url = `${this.askMePythonUrl}team-chat/stream`;
    const body = {
      client_name,
      study,
      session_id,
      bearer_token,
      query,
      stream,
      debug_mode,
      snapshot_enabled,
      crosstab_enabled,
      brand_analysis_enabled
    };

    return new Observable<any>((observer) => {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(async (response) => {
        if (!response.ok) {
          observer.error(new Error(`API responded with status ${response.status}: ${response.statusText}`));
          return;
        }
        if (!response.body) {
          observer.error('Response body is null');
          return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const parts = buffer.split('\n\n');
          buffer = parts.pop() || '';

          for (const part of parts) {
            const lines = part.split('\n');
            let eventType = 'message';
            let eventData = '';

            for (const line of lines) {
              if (line.startsWith('event: ')) {
                eventType = line.substring(7);
              } else if (line.startsWith('data: ')) {
                eventData = line.substring(6);
              }
            }

            if (eventData) {
              try {
                const parsedData = JSON.parse(eventData);
                // Return structured data to component
                observer.next({ event: eventType, data: parsedData });
              } catch (e) {
                // If not JSON, return as plain string
                observer.next({ event: eventType, data: eventData });
              }
            }
          }
        }
        observer.complete();
      }).catch((err) => {
        observer.error(err);
      });
      return () => { };
    });
  }

  mcodeChatAgentStream(
    client_name: string, study: string, session_id: string, bearer_token: string, query: string,
    stream: boolean = true, debug_mode: boolean = false,
    snapshot_enabled: boolean = true, crosstab_enabled: boolean = true, brand_analysis_enabled: boolean = true,
    enable_history: boolean = true, num_history_runs: number = 1
  ): Observable<any> {
    const url = `${this.askMePythonUrl}mcode-chat/stream`;
    const body = {
      client_name,
      study,
      session_id,
      bearer_token,
      query,
      stream,
      debug_mode,
      snapshot_enabled,
      crosstab_enabled,
      brand_analysis_enabled,
      enable_history,
      num_history_runs
    };

    return new Observable<any>((observer) => {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(async (response) => {
        if (!response.ok) {
          observer.error(new Error(`API responded with status ${response.status}: ${response.statusText}`));
          return;
        }
        if (!response.body) {
          observer.error('Response body is null');
          return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const parts = buffer.split('\n\n');
          buffer = parts.pop() || '';

          for (const part of parts) {
            const lines = part.split('\n');
            let eventType = 'message';
            let eventData = '';

            for (const line of lines) {
              if (line.startsWith('event: ')) {
                eventType = line.substring(7);
              } else if (line.startsWith('data: ')) {
                eventData = line.substring(6);
              }
            }

            if (eventData) {
              try {
                const parsedData = JSON.parse(eventData);
                observer.next({ event: eventType, data: parsedData });
              } catch (e) {
                observer.next({ event: eventType, data: eventData });
              }
            }
          }
        }
        observer.complete();
      }).catch((err) => {
        observer.error(err);
      });
      return () => { };
    });
  }

  teamPayloadAPI(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}team-payload`;
    return this.http.post<any>(url, payload).pipe(catchError(this.handleError));
  }

  snapshotPayloadAPI(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}snapshot-payload`;
    return this.http.post<any>(url, payload).pipe(catchError(this.handleError));
  }

  brandAnalysisPayloadAPI(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}brand-analysis-payload`;
    return this.http.post<any>(url, payload).pipe(catchError(this.handleError));
  }

  crosstabPayloadAPI(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}crosstab-payload`;
    return this.http.post<any>(url, payload).pipe(catchError(this.handleError));
  }

  snapshotPayloadService(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}snapshot-payload-service`;
    return this.http.post<any>(url, payload).pipe(catchError(this.handleError));
  }

  crosstabPayloadService(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}crosstab-payload-service`;
    return this.http.post<any>(url, payload).pipe(catchError(this.handleError));
  }

  brandAnalysisPayloadService(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}brand-analysis-payload-service`;
    return this.http.post<any>(url, payload).pipe(catchError(this.handleError));
  }

  // Generic streaming helper for new agents
  private genericAgentStream(url: string, body: any): Observable<any> {
    return new Observable<any>((observer) => {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(async (response) => {

        const contentType = response.headers.get('Content-Type') || '';
        if (contentType.includes('application/json')) {
          const json = await response.json();
          observer.next({ event: 'message', data: json });
          observer.complete();
          return;
        }

        if (!response.body) {
          console.error('[STREAM DEBUG] Response body is NULL!');
          observer.error('Response body is null');
          return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            break;
          }

          const decodedChunk = decoder.decode(value, { stream: true });
          buffer += decodedChunk;

          // Handle SSE messages (delimited by \n\n or \r\n\r\n)
          let boundary = buffer.indexOf('\n\n') !== -1 ? '\n\n' : (buffer.indexOf('\r\n\r\n') !== -1 ? '\r\n\r\n' : null);

          while (boundary) {
            const boundaryIndex = buffer.indexOf(boundary);
            const part = buffer.substring(0, boundaryIndex);
            buffer = buffer.substring(boundaryIndex + boundary.length);

            if (part.trim()) {
              this.processSsePart(part, observer);
            }
            boundary = buffer.indexOf('\n\n') !== -1 ? '\n\n' : (buffer.indexOf('\r\n\r\n') !== -1 ? '\r\n\r\n' : null);
          }
        }

        // Process any remaining buffer if it looks like a message
        if (buffer.trim()) {
          this.processSsePart(buffer, observer);
        }

        observer.complete();
      }).catch((err) => {
        console.error('[STREAM DEBUG] Fetch Error:', err);
        observer.error(err);
      });
      return () => { };
    });
  }

  private processSsePart(part: string, observer: any): void {
    const lines = part.split(/\r?\n/);
    let eventType = 'message';
    let eventData = '';
    let foundSsePrefix = false;

    for (const line of lines) {
      const trimmedLine = line.trim();
      if (trimmedLine.startsWith('event: ')) {
        eventType = trimmedLine.substring(7).trim();
        foundSsePrefix = true;
      } else if (trimmedLine.startsWith('data: ')) {
        eventData = trimmedLine.substring(6).trim();
        foundSsePrefix = true;
      }
    }

    if (foundSsePrefix && eventData) {
      try {
        const parsedData = JSON.parse(eventData);
        observer.next({ event: eventType, data: parsedData });
      } catch (e) {
        observer.next({ event: eventType, data: eventData });
      }
    } else if (!foundSsePrefix && part.trim()) {
      // Fallback for raw stream chunks without data: prefix
      observer.next({ event: 'message', data: part.trim() });
    }
  }

  // Module-Specific Q&A and Summary Streams
  snapshotQaAgentStream(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}snapshot-qa-agent/stream`;
    return this.genericAgentStream(url, payload);
  }

  crosstabQaAgentStream(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}crosstab-qa-agent/stream`;
    return this.genericAgentStream(url, payload);
  }

  brandAnalysisQaAgentStream(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}brand-analysis-qa-agent/stream`;
    return this.genericAgentStream(url, payload);
  }

  snapshotSummaryAgentStream(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}snapshot-summary-agent/stream`;
    return this.genericAgentStream(url, payload);
  }

  brandAnalysisSummaryAgentStream(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}brand-analysis-summary-agent/stream`;
    return this.genericAgentStream(url, payload);
  }

  crosstabSummaryAgentStream(payload: any): Observable<any> {
    const url = `${this.askMePythonUrl}crosstab-summary-agent/stream`;
    return this.genericAgentStream(url, payload);
  }

  private handleError(error: HttpErrorResponse) {
    console.error('API Error:', error);
    return throwError(() => error);
  }

}

